<template>
  <div>
    <el-card class="box-card tablecard mt10 textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-gift fs14" /> 逐年新增的公开项目和已经提交的项目 </span>
      </div>
      <div>
        <el-switch
          class="mb20"
          v-model="isShowlable"
          active-text="显示数值"
          @change="handleChangelable">
        </el-switch>
        <div id="myCharts" :style="{height: '450px'}"></div>
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10 textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-gift fs14" /> 逐年公开项目的比例 </span>
      </div>
      <div>
        <el-switch
          class="mb20"
          v-model="isShowlable2"
          active-text="显示数值"
          @change="handleChangelable2">
        </el-switch>
        <div id="myCharts2" :style="{height: '450px'}"></div>
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10 textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-gift fs14" /> 累计公开项目和已经提交的项目 </span>
      </div>
      <div>
        <el-switch
          class="mb20"
          v-model="isShowlable3"
          active-text="显示数值"
          @change="handleChangelable3">
        </el-switch>
        <div id="myCharts3" :style="{height: '450px'}"></div>
      </div>
    </el-card>
    <el-card class="box-card tablecard mt10 textLeft" shadow="never">
      <div slot="header" class="clearfix">
        <span><i class="fa fa-gift fs14" /> 累计公开项目的比例 </span>
      </div>
      <div>
        <el-switch
          class="mb20"
          v-model="isShowlable4"
          active-text="显示数值"
          @change="handleChangelable4">
        </el-switch>
        <div id="myCharts4" :style="{height: '450px'}"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getStatProjectNewByTime, getStatProjectAllByTime } from '@/api'
import echarts from 'echarts'
export default {
  name: 'statistics',
  data() {
    return {
      option: {
        title: {
          // text: 'World Population',
          subtext: '',
          left: '5%'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: { show: true },
            // dataView: { show: true, readOnly: false },
            // magicType: { show: true, type: ['line', 'bar', 'stack'] },
            magicType: { show: true, type: ['line', 'bar'] },
            // restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
          // axisLabel: {
          //   interval: 0,
          //   rotate: 33
          // }
        },
        yAxis: {
          type: 'value',
          name: '个',
          // boundaryGap: [0, 0.01],
          min: 'dataMin',
          axisLabel: {
            formatter: function (value) {
                // 将数值取整
                return Math.round(value);
            }
          }
        },
        height: 300,
        dataZoom: [
          {
            type: 'slider',
            bottom: '20px'
          }
        ],
        series: [
          {
            name: '逐年新增的已经提交的项目数',
            type: 'bar',
            data: [],
            label: {
              show: false,
              position: 'top'
            }
          },
          {
            name: '逐年新增的公开项目数',
            type: 'bar',
            data: [],
            label: {
              show: false,
              position: 'top'
            }
          }
        ]
      },
      option2: {
        title: {
          // text: 'Stacked Line'
          subtext: '',
          left: '5%'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          show: false
        },
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: { show: true },
            // dataView: { show: true, readOnly: false },
            // magicType: { show: true, type: ['line', 'bar', 'stack'] },
            magicType: { show: true, type: ['line', 'bar'] },
            // restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
          // axisLabel: {
          //   interval: 0,
          //   rotate: 33
          // }
        },
        yAxis: [{
          type: 'value',
          name: 'GB',
          min: 'dataMin'
        }],
        height: 300,
        dataZoom: [
          {
            type: 'slider',
            bottom: '20px'
          }
        ],
        series: [
          {
            name: '累计已经提交的项目数',
            type: 'line',
            data: [],
            label: {
              show: false,
              position: 'top'
            }
          },
          {
            name: '累计公开的项目数',
            type: 'line',
            data: [],
            label: {
              show: false,
              position: 'top'
            }
          }
        ]
      },
      ajax_data: {
        search:{
          stat_type: 'year'
        },
        page:{
          startPage: 1,
          pageLength: 0
        },
        order:{
          item: '',
          type: ''
        }
      },
      title3: '',
      chartsArr1: [],
      chartsArr2: [],
      chartsArr3: [],
      chartsArr4: [],
      xAxis1: [],
      xAxis2: [],
      xAxis3: [],
      xAxis4: [],
      isShowlable: false,
      isShowlable2: false,
      isShowlable3: false,
      isShowlable4: false
    }
  },
  mounted() {
    getStatProjectNewByTime(this.ajax_data).then(res => {
      this.chartsArr1 = res.result
      let dataArr = []
      let subArr = []
      let pubArr = []
      let percentArr = []
      // console.log(resultArr)
      this.chartsArr1.map(item => {
        dataArr.push(item.statyear)
        subArr.push(item.submitted)
        pubArr.push(item.public)
        percentArr.push(item.public_percent)
      })
      this.option.xAxis.data = this.xAxis1 = this.option2.xAxis.data = dataArr
      this.option.series[0].data = subArr
      this.option.series[1].data = pubArr
      this.option2.yAxis[0].name = '%'
      this.option2.series[0].name = '逐年公开项目的比例'
      this.option2.series[0].data = percentArr
      let charts = this.$echarts.init(document.getElementById('myCharts'))
      charts.setOption(this.option)
      let charts2 = this.$echarts.init(document.getElementById('myCharts2'))
      charts2.setOption(this.option2)
    })
    getStatProjectAllByTime(this.ajax_data).then(res => {
      this.chartsArr2 = res.result
      let dataArr2 = []
      let subArr2 = []
      let pubArr2 = []
      let percentArr2 = []
      // console.log(resultArr)
      this.chartsArr2.map(item => {
        dataArr2.push(item.statyear)
        subArr2.push(item.submitted)
        pubArr2.push(item.public)
        percentArr2.push(item.public_percent)
      })
      this.option2.xAxis.data = this.xAxis2 = dataArr2
      this.option2.series[0].name = '累计已经提交的项目数'
      this.option2.series[1].name = '累计公开的项目数'
      this.option2.series[0].data = subArr2
      this.option2.series[1].data = pubArr2
      this.option2.legend.show = true
      // this.option2.yAxis[0].name = '%'
      // this.option2.series[0].name = '逐年公开项目的比例'
      // this.option2.series[0].data = percentArr
      let charts3 = this.$echarts.init(document.getElementById('myCharts3'))
      charts3.setOption(this.option2)
      this.option2.series[0].name = '累计公开项目的比例'
      this.option2.series[1] = {}
      this.option2.series[0].data = percentArr2
      this.option2.legend.show = false
      let charts4 = this.$echarts.init(document.getElementById('myCharts4'))
      charts4.setOption(this.option2)
    })
  },
  created() {
  },
  methods: {
    handleChangelable(val) {
      this.option.xAxis.data = this.xAxis1
      let dataArr = []
      let subArr = []
      let pubArr = []
      // console.log(resultArr)
      this.chartsArr1.map(item => {
        dataArr.push(item.statyear)
        subArr.push(item.submitted)
        pubArr.push(item.public)
      })
      this.option.series[0].data = subArr
      this.option.series[1].data = pubArr

      this.option.series[0].label.show = val
      this.option.series[1].label.show = val
      let charts = this.$echarts.init(document.getElementById('myCharts'))
      charts.setOption(this.option)
    },
    handleChangelable2(val) {
      let dataArr = []
      let subArr = []
      let pubArr = []
      let percentArr = []
      // console.log(resultArr)
      this.chartsArr1.map(item => {
        dataArr.push(item.statyear)
        subArr.push(item.submitted)
        pubArr.push(item.public)
        percentArr.push(item.public_percent)
      })
      this.xAxis1 = this.option2.xAxis.data = dataArr
      this.option2.yAxis[0].name = '%'
      this.option2.series[0].name = '逐年公开项目的比例'
      this.option2.series[0].data = percentArr
      this.option2.series[0].label.show = val
      let charts2 = this.$echarts.init(document.getElementById('myCharts2'))
      charts2.setOption(this.option2)
    },
    handleChangelable3(val) {
      let dataArr2 = []
      let subArr2 = []
      let pubArr2 = []
      let percentArr2 = []
      // console.log(resultArr)
      this.chartsArr2.map(item => {
        dataArr2.push(item.statyear)
        subArr2.push(item.submitted)
        pubArr2.push(item.public)
      })
      this.option2.xAxis.data = this.xAxis2 = dataArr2
      this.option2.series[0].name = '累计已经提交的项目数'
      this.option2.series[0].data = subArr2
      this.option2.series[1] = {
        name: '累计公开的项目数',
        type: 'line',
        data: pubArr2,
        label: {
          show: val,
          position: 'top'
        }
      }
      this.option2.legend.show = true
      this.option2.series[0].label.show = val
      // this.option2.yAxis[0].name = '%'
      // this.option2.series[0].name = '逐年公开项目的比例'
      // this.option2.series[0].data = percentArr
      let charts3 = this.$echarts.init(document.getElementById('myCharts3'))
      charts3.setOption(this.option2)
    },
    handleChangelable4(val) {
      let dataArr2 = []
      let subArr2 = []
      let pubArr2 = []
      let percentArr2 = []
      // console.log(resultArr)
      this.chartsArr2.map(item => {
        dataArr2.push(item.statyear)
        subArr2.push(item.submitted)
        pubArr2.push(item.public)
        percentArr2.push(item.public_percent)
      })
      this.option2.xAxis.data = this.xAxis2 = dataArr2
      this.option2.series[0].name = '累计公开项目的比例'
      this.option2.series[1] = {}
      this.option2.series[0].data = percentArr2
      this.option2.legend.show = false
      this.option2.series[0].label.show = val
      let charts4 = this.$echarts.init(document.getElementById('myCharts4'))
      charts4.setOption(this.option2)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
